import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function Carousel({ settings, blocks }) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  return (
    <div className={`flex ${isMobile ? "flex-col" : "flex-row"} gap-8`}>
      <div className={`flex flex-col gap-6 lg:gap-11 ${isMobile ? "text-center items-center pr-3" : "max-w-[386px]"}`}>
        <h2 className={isMobile ? settings.section.title_font_style_mobile : settings.section.title_font_style}>{settings.section.title}</h2>
        <p className={isMobile ? settings.section.content_font_style_mobile : settings.section.content_font_style}>{settings.section.content}</p>
      </div>
      <div className="specialised-services-carousel "
        data-flickity={`{` +
          `"freeScroll": ${settings.section.use_freescroll}, ` +
          `"wrapAround": true, ` +
          `"cellAlign": "left", ` +
          `"pageDots": ${settings.section.show_indicators}, ` +
          `"prevNextButtons": ${settings.section.show_navbuttons}, ` +
          `"groupCells": 1` +
          `}`}
        {...({
          "x-data": "carousel",
          "x-init": `$nextTick(() => { initialise(${settings.section.show_indicators}, ${settings.section.show_navbuttons}, ${settings.section.fade_edgeitems}, false, 0, 'expertise-carousel', true, ${settings.section.use_freescroll}) })`,
          "x-ref": "carousel",
        })}
      >
        {blocks.map((block, index) => (
          <div key={index} className="flex flex-col w-full gradient-border gap-[35px] lg:min-w-auto px-8 py-12 mr-[20px] lg:mr-[32px]"
            style={{
              maxWidth: `${isMobile ? settings.section.visible_slide_width_mobile : 100}%`,
            }}
          >
            {block.settings.title &&
              <h3 className={isMobile ? block.settings.title_font_style_mobile : block.settings.title_font_style}>
                {block.settings.title}
              </h3>
            }
            {block.settings.content &&
              <p className={isMobile ? block.settings.content_font_style_mobile : block.settings.content_font_style}
                dangerouslySetInnerHTML={{ __html: block.settings.content }}
              ></p>
            }
            {block.settings.button_text &&
              <a href={block.settings.button_url} className="link link-primary cursor-pointer py-3 pr-6">
                <span className="button__label">{block.settings.button_text}</span>
                <span className="icon-right-arrow-alt button__icon no-underline"></span>
              </a>
            }
          </div>
        ))}
      </div>
    </div>
  )
}